﻿import { getProductDetailImpression, sendDataLayer } from "../../components/ecommerce/ecommerce";
import { getIdentifierFromData } from "../../helpers";
import { getTranslations } from "../../translations";
import { Popup, PopupButton, PopupContentOptions, PopupPosition } from "../../utilities/popup";

declare let productInfoList;
let favoritePopup: FavoritePopup;

document.addEventListener("DOMContentLoaded", () =>
{
    if (!favoritePopup)
    {
        favoritePopup = new FavoritePopup();
    }
});

export const setFavoritePopup = (popup: FavoritePopup) => favoritePopup = popup;

export class FavoritePopup
{
    popup: Popup;

    constructor()
    {
        this.createPopup();

        // Add events
        this.addEvents();
    }

    private createPopup = () =>
    {
        if (!this.popup)
        {
            this.popup = new Popup({
                id: 'favoritemodal',
                title: "Favorieten",
                content: '',
                closeButton: true,
            });
        }
    }

    private addEvents = () =>
    {
        const instance = this;
        const articleButtons = document.querySelectorAll(".js-favorite-article");

        articleButtons.forEach((item: HTMLElement, index) =>
        {
            item.addEventListener("click", () =>
            {
                instance.toggleFavorite(item);
            });
        });
    }

    public toggleFavorite = (item: HTMLElement) =>
    {
        const instance = this;
        const articleID = getIdentifierFromData(item, "articleid");
        let articleImage = $(`#featureditem-${articleID}`).find("img")[0];

        if (!articleImage) articleImage = $(`[data-articleid="${articleID}"]`).find("img")[0];

        if ($(item).hasClass("active"))
        {
            const listID = getIdentifierFromData(item, "listid");
            instance.removeFromFavoriteList(listID, articleID, item);
        }
        else
            instance.showPopup(item, articleID, articleImage);
    }

    private showPopup = (source: HTMLElement, articleID: number, articleImage: HTMLImageElement) =>
    {
        const instance = this;
        if ($(source).hasClass("active"))
            return;

        const json = "{articleID:" + articleID + "}";

        $.ajax({
            url: "/Services/Modules/Webshop.asmx/GetFavoritesLists",
            type: "POST",
            data: json,
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            complete: function (data)
            {
                if (data.responseJSON != undefined && data.responseJSON.d != "")
                {
                    const modalContent = data.responseJSON.d;
                    const radioButtons: Array<PopupContentOptions> = [];
                    const content = document.createElement("div");
                    content.classList.add("g-popup__contentholder-inner", "g-popup__contentholder-inner--list", "g-popup__contentholder-inner--nomargin");

                    const contentSubtitle = document.createElement("div");
                    contentSubtitle.classList.add("g-popup__contentholder-inner--subtitle");
                    contentSubtitle.innerText = getTranslations().txtFavoritePopupsubtitle;
                    let image

                    if (articleImage) {
                        image = articleImage.cloneNode(false) as HTMLImageElement;
                        image.className = "g-popup__contentholder-inner--image";
                        content.append(image);
                    }

                    content.append(contentSubtitle);

                    $(modalContent).find(".js-favorite-radio").each((index, item) =>
                    {
                        const radio = $(item).find("[type=radio]")[0] as HTMLInputElement;

                        const radioHolder = document.createElement("div");
                        radioHolder.classList.add("c-popup__radio-holder");

                        const radioInput = document.createElement("input");
                        radioInput.classList.add("u-customradio__input");
                        radioInput.setAttribute("type", "radio");
                        radioInput.setAttribute("id", radio.id);
                        radioInput.setAttribute("name", radio.name);
                        radioInput.setAttribute("value", radio.value);

                        const radioLabel = document.createElement("label");
                        radioLabel.classList.add("u-customradio__label");
                        radioLabel.setAttribute("for", radio.id);

                        const radioSpan = document.createElement("span");
                        radioSpan.classList.add("u-customradio__span");

                        radioLabel.textContent = $(item).find("label").text();
                        radioLabel.prepend(radioSpan);

                        radioHolder.append(radioInput);
                        radioHolder.append(radioLabel);
                        content.append(radioHolder);

                        const radioButton = new PopupContentOptions(radio.id, radio.checked);
                        radioButton.text = $(item).find("label").text();
                        radioButton.name = radio.name;
                        radioButton.value = radio.value;
                        radioButtons.push(radioButton);
                    });

                    const saveButton = new PopupButton();
                    saveButton.label = getTranslations().txtAdd;
                    saveButton.className = "btn btn-green full-width";
                    saveButton.onClick = () =>
                    {
                        let value = 0;

                        const tmpValue = $(instance.popup.getContent()).find("[type=radio]:checked").val();
                        if (tmpValue)
                            value = parseInt(tmpValue.toString());

                        instance.AddToFavoriteList(articleID, source, value);
                        instance.popup.destroy();
                    };
                    instance.popup = new Popup({
                        id: "fav-choose-list",
                        closeButton: true,
                        content: content,
                        buttons: [saveButton],
                        title: getTranslations().txtFavoritePopuptitle,
                        mobilePosition: PopupPosition.Popup,
                        grid: false
                    });

                    if ($(modalContent).find("input[type=\"radio\"]").length > 1)
                        instance.popup.show();
                    else
                    {
                        // We only have 1 list, directly add it!
                        $($(modalContent).find("input[type=\"radio\"]")[0]).prop("checked", true);
                        const listID = parseInt($(modalContent).find("input[type=\"radio\"]:checked").val() as string ?? "0");
                        instance.AddToFavoriteList(articleID, source, listID);
                    }
                }
                else
                    instance.AddToFavoriteList(articleID, source, 0);
            }
        });
    }

    private AddToFavoriteList = (articleID: number, parent: HTMLElement, listID: number) =>
    {
        const instance = this;

        if ($(parent).hasClass("active"))
            return;

        var listItemId = $(instance.popup.getContent()).find("input[name='radio-choose-fav-list']:checked").val();

        if (typeof (listItemId) == typeof (undefined))
            listItemId = listID;

        var dt = "{articleID:" + articleID + ", listID:" + listItemId + "}";

        $.ajax({
            type: "POST",
            url: "/Services/Modules/Webshop.asmx/AddArticleToFavoritesList",
            data: dt,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (data)
            {
                instance.popup.hide();

                var impressionSelector = "";
                if (articleID > 0)
                {
                    if ($(".js-impression[data-articleid=" + articleID + "]").length > 0)
                        impressionSelector = ".featureditem[data-articleid=" + articleID + "]";
                }

                var articleNumber = null;
                if ($(".js-favorite-article").length > 0)
                {
                    $(".js-favorite-article[data-articleid=" + articleID + "]").addClass("active");
                    $(parent).addClass("active");
                }
                else if ($(".product-detail").length > 0 && $(".btn-add-favorite").length > 0)
                {
                    var itemSelector = `.btn-add-favorite[data-aid=${articleID}]`;

                    if ($(itemSelector).length <= 0)
                        itemSelector = ".btn-add-favorite";

                    if (data.d != null && data.d.length > 0)
                    {
                        var favContent = decodeURIComponent(data.d);
                        $(itemSelector).replaceWith(favContent);
                    }

                    // Set a small delay so the transition can play.
                    setTimeout(function () { $(itemSelector).addClass("active"); }, 1);
                    articleNumber = $("[itemprop='sku']").text();
                }
                else
                {
                    $(parent).addClass("active");
                }

                if (typeof (productInfoList) !== typeof (undefined))
                    articleNumber = productInfoList[articleID];
                else if (typeof (articleID) !== typeof (undefined))
                {
                    if ($(impressionSelector).length > 0)
                    {
                        var tempArticleNumber = $(impressionSelector).data("articlenumber");
                        if (typeof (tempArticleNumber) !== typeof (undefined) &&
                            tempArticleNumber != null
                        )
                            articleNumber = tempArticleNumber;
                    }
                }

                // Update or set header icon counter
                if ($(".js-header-fav-counter").length > 0)
                {
                    let currentNumber = 0;
                    const counterIconNumber = $(".js-header-fav-counter").html();

                    if (typeof (counterIconNumber) != typeof (undefined) && counterIconNumber !== '')
                        currentNumber = parseInt(counterIconNumber) + 1;
                    else
                        currentNumber = 1;

                    $(".js-header-fav-counter").html(currentNumber.toString());
                    instance.headerFavIconAnimation();
                }

                sendDataLayer({ ecommerce: null });  // Clear the previous ecommerce object.
                sendDataLayer({
                    'event': 'Favorieten',
                    'category': 'favorieten',
                    'action': 'toevoegen',
                    'label': '' + articleNumber + '',
                    'ecommerce': {
                        'items': [getProductDetailImpression($(impressionSelector)[0])]
                    }
                });
            }
        });
    }

    public removeFromFavoriteList = (listID, articleID, source) =>
    {
        const instance = this;
        if (!$(source).hasClass("active"))
            return;

        var url = "/Services/Modules/Webshop.asmx/RemoveArticleFromFavoritesList";

        if (listID == undefined || listID <= 0)
            url = "/Services/Modules/Webshop.asmx/RemoveArticleFromFavorites";

        $.ajax({
            type: "POST",
            url: url,
            data: "{listID:" + listID + ", articleID:" + articleID + "}",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (data)
            {
                if (data.d)
                {
                    var impressionSelector = "";
                    if (typeof (articleID) !== typeof (undefined))
                    {
                        if ($(".featureditem[data-articleid=" + articleID + "]").length > 0)
                            impressionSelector = ".featureditem[data-articleid=" + articleID + "]";

                        if ($(".featureditem .product-block[data-articleid=" + articleID + "]").length > 0)
                            impressionSelector = ".featureditem .product-block[data-articleid=" + articleID + "]";
                    }

                    if (impressionSelector === "")
                        impressionSelector = "#product-holder";

                    var articleNumber = null;
                    if ($(".category-favorite-icon").length > 0)
                    {
                        $(".favorite-login-content").removeClass("hidden");
                        $("#fav-holder-added").addClass("hidden");
                        $("#favholder").find("select").val("0");

                        $(source).removeClass("active");

                        articleNumber = productInfoList[articleID];
                    }
                    else if ($(".product-detail").length > 0 &&
                        $(".btn-add-favorite").length > 0)
                    {
                        $(".btn-add-favorite").removeClass("active");

                        articleNumber = $("[itemprop='sku']").text();
                    }
                    else
                    {
                        $(source).removeClass("active");

                        if (typeof (productInfoList) !== typeof (undefined))
                            articleNumber = productInfoList[articleID];
                        else if (typeof (articleID) !== typeof (undefined))
                        {
                            if ($(impressionSelector).length > 0)
                            {
                                var tempArticleNumber = $(impressionSelector).data("articlenumber");
                                if (typeof (tempArticleNumber) !== typeof (undefined) &&
                                    tempArticleNumber != null
                                )
                                    articleNumber = tempArticleNumber;
                            }
                        }
                    }

                    // Update or set header icon counter
                    if ($(".js-header-fav-counter").length > 0)
                    {
                        let currentNumber = 0;
                        const counterIconNumber = $(".js-header-fav-counter").html();

                        if (typeof (counterIconNumber) != typeof (undefined) && counterIconNumber !== '')
                            currentNumber = parseInt(counterIconNumber) - 1;
                        else
                            currentNumber = 0;

                        $(".js-header-fav-counter").html(currentNumber > 0 ? currentNumber.toString() : "");
                        instance.headerFavIconAnimation();
                    }

                    if ($(source).closest(".js-favorite-page-article")?.length > 0)
                    {
                        $(source).closest(".js-favorite-page-article").remove();
                        let amount = parseInt($(source).closest(".js-favorite-list").find(".article-amount").text().replace("(", "").replace(")", ""));
                        amount--;
                        $(source).closest(".js-favorite-list").find(".article-amount").text(`(${amount})`);
                    }

                    sendDataLayer({ ecommerce: null });  // Clear the previous ecommerce object.
                    sendDataLayer({
                        'event': 'Favorieten',
                        'category': 'favorieten',
                        'action': 'verwijderen',
                        'label': '' + articleNumber + '',
                        'ecommerce': {
                            'items': [getProductDetailImpression($(impressionSelector)[0])]
                        }
                    });
                }
            }
        });
    }

    private openFavoriteLoginPopup = (articleID, parent) =>
    {
        if (!articleID)
        {
            articleID = $("#shopart").val();
            parent = document.querySelector('#favlistselectionpopup' + $("#shopart").val());
        }

        if (shopConfig().userLoggedIn)
        {
            // TODO LOGIN POPUP
        }
        else
            this.AddToFavoriteList(articleID, parent, 0);
    }

    private headerFavIconAnimation()
    {
        $(".js-header-fav").addClass("updating");

        setTimeout(function ()
        {
            $(".js-header-fav").removeClass("updating");
        }, 400);
    }
}